import React, { useEffect, useState } from 'react';
import logo from './logo.svg';
import { Button, Divider, Drawer, Flex, Layout, Modal, Space, Typography } from 'antd';
import './App.css';
import { useParams } from "react-router-dom"

const { Header, Footer, Sider, Content } = Layout;
function App() {
  const params = useParams();
  useEffect(() => {
    setYy(params.yy||'');
    setMm(params.mm||'');
    setDd(params.dd||'');
    setPdfname(encodeURIComponent(params.pdfname||''));
    console.log(params)
    console.log(encodeURIComponent(params.pdfname||''))
  }, [params]);
  const [yy,setYy] = useState('');
  const [mm,setMm] = useState('');
  const [dd,setDd] = useState('');
  const [pdfname,setPdfname] = useState('');
  const [open, setOpen] = useState(false);
  const headerStyle: React.CSSProperties = {
    textAlign: 'center',
    color: '#fff',
    height: 64,
    paddingInline: 48,
    fontWeight: 'bold',
    fontSize: '24px',
    lineHeight: '64px',
    backgroundColor: '#FF6600',
  };
  
  const contentStyle: React.CSSProperties = {
    textAlign: 'center',
    height: 'calc(100vh - 172px)',
    color: '#fff',
    backgroundColor: '#0958d9',
  };

  const siderStyle: React.CSSProperties = {
    textAlign: 'center',
    lineHeight: '64px',
    color: '#fff',
    backgroundColor: '#1677ff',
  };
  
  const onClose = () => {
    setOpen(false);
  };
  const footerStyle: React.CSSProperties = {
    textAlign: 'center',
    color: '#fff',
    lineHeight: '35px',
    fontSize: '24px',
    paddingInline: 48,
  };
  
  const layoutStyle = {
    borderRadius: 8,
    overflow: 'hidden',
    lineHeight: '100vh',
  };
  const showModal = () => {
    Modal.confirm({
      title: '拆分/移出',
      content: '确定要拆分/移出吗？',
      onOk: () => {
        console.log('OK');
        
      }
    })
  }

  return (
    
    <div className="app-container">

    <Layout style={layoutStyle}>
    <Header style={headerStyle}>广州金至检测技术有限公司</Header>
    <Content style={contentStyle}> <iframe src={`/pdfjs-2.2.228-dist/web/viewer.html?file=/iLab/pdf/${yy}/${mm}/${dd}/${pdfname}`} width={'100%'} height={'100%'} />
    </Content>
    <Footer style={footerStyle}>
    <Space style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }} align="start">
      <Button style={{fontSize:20,fontWeight: 'bold'}} type="link" href="https://www.kingtest.com.cn">关于金至</Button>
      <Divider  type="vertical" style={{ backgroundColor: '#000',fontSize:50 }} />
      <Button style={{fontSize:20,fontWeight: 'bold'}} type="link" onClick={()=> {setOpen(true)}}>联系我们</Button>
  </Space>
    </Footer>
  </Layout>
  <Drawer
        title="咨询热线"
        placement="bottom"
        closable={false}
        open={open}
        height={148}
        onClose={onClose}
      >
        <a style={{fontSize:24,fontWeight: 'bold',textAlign:'center'}} href="tel:020222832222"><span >020-222832222</span></a>
      </Drawer>
     </div>


  );
}

export default App;
